'use client'

import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

import { SeoStructureData } from './modules/SeoStructureData'

interface SeoContextProps {
  seoStructuredData: any
}

const SeoContext = createContext<SeoContextProps | undefined>(undefined)

interface SeoProviderProps {
  children: ReactNode
  seoStructuredData: any
}

export const SeoProvider = ({ children, seoStructuredData }: SeoProviderProps) => {
  return (
    <SeoContext.Provider value={{ seoStructuredData }}>
      <SeoStructureData seoStructuredData={seoStructuredData} />
      {children}
    </SeoContext.Provider>
  )
}

export const useSeoStrucureData = () => {
  const context = useContext(SeoContext)
  if (!context) {
    throw new Error('useSeoStrucureData must be used within a SeoProvider')
  }
  return context
}
